import $ from 'jquery';
import {Component} from '../../../component';

/* global Cookies */
export class CookieBar extends Component {

    /**
     * Constructor
     */
    constructor(context) {
        super(context);

        this.cookieName = 'ctheme_cookie_bar';
        this.$cookieBarEl = null;
    }

    /**
     * setup
     */
    setup() {
        this.$cookieBarEl = $('.js-c-cookie-bar');
        if (!this.$cookieBarEl.length) {
            return;
        }

        // Bind events
        $(document).on('click', '.js-c-cookie-bar__accept-btn', this.onAccept.bind(this));

        if (Cookies.get(this.cookieName)) {
            this.$cookieBarEl.addClass('hidden');
        } else {
            this.$cookieBarEl.removeClass('hidden');
        }
    }

    /**
     * onAccept
     *
     * @param {object} evt
     */
    onAccept(evt) {
        if (evt) {
            evt.preventDefault();
        }

        $(evt.target).closest(this.$cookieBarEl).addClass('hidden');

        Cookies.set(this.cookieName, true, {expires: 365});
    }
}
